import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/local/environment';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  creddoPage = environment.creddoPage;
  isMinasidor = false;

  constructor(
    private route: ActivatedRoute, 
    private authService: AuthService
  ) {
    this.route.queryParams.subscribe((qp) => {
      const { applicationId, token } = qp;
      this.isMinasidor = !!applicationId && !!token;
    });
  }

  ngOnInit(): void { }

  logoLink(): void {
    window.open(this.creddoPage, '_self');
  }

  goBackToMinasidor(): void {
    window.location.assign(`${environment.summaryRedirectUrl}start?jwt=${this.authService.accessToken}`);
  }
}
